import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Column, Row, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { formatShortMonthUSDate } from '~/utils';
import styles from './TimeActivityDetails.module.scss';
export const GetTimeActivityDetailsTID = (parentTestId)=>getTestIds(parentTestId);
export const TimeActivityDetails = (param)=>{
    let { timeActivity, testId } = param;
    const { t } = useLocaleKeys('components.billClientModal.timeActivities');
    const { TimeActivityDetailsTestIds } = useMemo(()=>GetTimeActivityDetailsTID(testId), [
        testId
    ]);
    const { date, hours, minutes, note } = timeActivity;
    return /*#__PURE__*/ _jsxs(Column, {
        children: [
            /*#__PURE__*/ _jsxs(Row, {
                alignItems: "center",
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        className: styles.timeActivityLabel,
                        children: t.detailsLabels.date()
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        testId: TimeActivityDetailsTestIds.Date(),
                        children: formatShortMonthUSDate(new Date(date))
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Row, {
                alignItems: "center",
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        className: styles.timeActivityLabel,
                        children: t.detailsLabels.duration()
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        testId: TimeActivityDetailsTestIds.Duration(),
                        children: t.duration({
                            hours,
                            minutes
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Row, {
                alignItems: "center",
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        className: styles.timeActivityLabel,
                        children: t.detailsLabels.notes()
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        testId: TimeActivityDetailsTestIds.Note(),
                        className: styles.notes,
                        children: note
                    })
                ]
            })
        ]
    });
};
